import { ApiGroup } from "../types/ApiTypes"

export const GiftCategoryApi: ApiGroup = {
    GetList: {
        title: "기프티콘 카테고리 목록 조회",
        method: "GET",
        url: "/api/v1/gift-categories",
        paramz: {},
    },
    Create: {
        title: "기프티콘 카테고리 등록",
        method: "POST",
        url: "/api/v1/gift-categories",
        paramz: {},
    },
    Update: {
        title: "기프티콘 카테고리 수정",
        method: "PUT",
        url: "/api/v1/gift-categories/:id",
        pathParams: ["id"],
        paramz: {},
    },
    Delete: {
        title: "기프티콘 카테고리 삭제",
        method: "DELETE",
        url: "/api/v1/gift-categories/:id",
        pathParams: ["id"],
        paramz: {},
    },
}
